/* eslint-disable camelcase */
import axios from "axios";
//Limitless
import { createPublicAPIRequest } from "@limitless/common/utils/PublicAPIUtils";
import { handleAPIFailure } from "@limitless/common/utils/api-log-helper/APILogHelper";

/**
 * Customers can attach url and captions as dialogues
 *
 * @param {object} message
 * @param {object} body
 */

export const customerAttachment = (message, body) => {
  return new Promise((resolve, reject) => {
    const data = {
      ...body
    };
    const {
      messageId
    } = message;
    const apiConfig = createPublicAPIRequest("put", `messages/${messageId}/attach`, {
      access_key: message.accessKey
    }, data, null);
    axios(apiConfig).then(() => resolve()).catch(error => {
      handleAPIFailure(error, "CustomeAttachmnetAPI customerAttachment");
      reject();
    });
  });
};